export const LOCATION_STEPS = [
	'Click the icon in the address bar next to ',
	'Select "Website Settings"',
	'Find "Location" and click the dropdown menu',
	'Choose "Allow" for ',
];

export const LOCATION_MODAL_KEY = 'showLocationModal';